import {PropertyRegime} from "../shared/enums/propertyRegime.enum";
import {EstadoCivil} from "../shared/enums/estadoCivil.enum";
import {DocumentType} from "../shared/enums/documentType.enum";
import {AccountType} from "../shared/enums/accountType.enum";

export const nationalities = [
  {optValue: 'Brasileira', optLabel: 'Brasileira'},
  {optValue: 'Afegã', optLabel: 'Afegã'},
  {optValue: 'Alemã', optLabel: 'Alemã'},
  {optValue: 'Argelina', optLabel: 'Argelina'},
  {optValue: 'Argentina', optLabel: 'Argentina'},
  {optValue: 'Americana', optLabel: 'Americana'},
  {optValue: 'Angolana', optLabel: 'Angolana'},
  {optValue: 'Armênia', optLabel: 'Armênia'},
  {optValue: 'Australiana', optLabel: 'Australiana'},
  {optValue: 'Austríaca', optLabel: 'Austríaca'},
  {optValue: 'Bahamense', optLabel: 'Bahamense'},
  {optValue: 'Belga', optLabel: 'Belga'},
  {optValue: 'Bielorrussa', optLabel: 'Bielorrussa'},
  {optValue: 'Boliviana', optLabel: 'Boliviana'},
  {optValue: 'Búlgara', optLabel: 'Búlgara'},
  {optValue: 'Britânica', optLabel: 'Britânica'},
  {optValue: 'Cabo Verdiana', optLabel: 'Cabo Verdiana'},
  {optValue: 'Camaronesa', optLabel: 'Camaronesa'},
  {optValue: 'Canadense', optLabel: 'Canadense'},
  {optValue: 'Cazaque', optLabel: 'Cazaque'},
  {optValue: 'Chilena', optLabel: 'Chilena'},
  {optValue: 'Chinesa', optLabel: 'Chinesa'},
  {optValue: 'Colombiana', optLabel: 'Colombiana'},
  {optValue: 'Costa Riquenha', optLabel: 'Costa Riquenha'},
  {optValue: 'Croata', optLabel: 'Croata'},
  {optValue: 'Cubana', optLabel: 'Cubana'},
  {optValue: 'Dinamarquesa', optLabel: 'Dinamarquesa'},
  {optValue: 'Eslovena', optLabel: 'Eslovena'},
  {optValue: 'Egípcia', optLabel: 'Egípcia'},
  {optValue: 'Equatoriana', optLabel: 'Equatoriana'},
  {optValue: 'Escocesa', optLabel: 'Escocesa'},
  {optValue: 'Espanhola', optLabel: 'Espanhola'},
  {optValue: 'Finlandesa', optLabel: 'Finlandesa'},
  {optValue: 'Francesa', optLabel: 'Francesa'},
  {optValue: 'Grega', optLabel: 'Grega'},
  {optValue: 'Guianense', optLabel: 'Guianense'},
  {optValue: 'Holandesa', optLabel: 'Holandesa'},
  {optValue: 'Húngara', optLabel: 'Húngara'},
  {optValue: 'Iraquiana', optLabel: 'Iraquiana'},
  {optValue: 'Irlandesa', optLabel: 'Irlandesa'},
  {optValue: 'Iraniana', optLabel: 'Iraniana'},
  {optValue: 'Iugoslava', optLabel: 'Iugoslava'},
  {optValue: 'Italiana', optLabel: 'Italiana'},
  {optValue: 'Israelense', optLabel: 'Israelense'},
  {optValue: 'Indiana', optLabel: 'Indiana'},
  {optValue: 'Japonesa', optLabel: 'Japonesa'},
  {optValue: 'Jordana', optLabel: 'Jordana'},
  {optValue: 'Libanesa', optLabel: 'Libanesa'},
  {optValue: 'Mexicana', optLabel: 'Mexicana'},
  {optValue: 'Moçambicana', optLabel: 'Moçambicana'},
  {optValue: 'Mongol', optLabel: 'Mongol'},
  {optValue: 'Nepalesa', optLabel: 'Nepalesa'},
  {optValue: 'Nigeriana', optLabel: 'Nigeriana'},
  {optValue: 'Norueguesa', optLabel: 'Norueguesa'},
  {optValue: 'Norte Coreana', optLabel: 'Norte Coreana'},
  {optValue: 'Panamense', optLabel: 'Panamense'},
  {optValue: 'Paraguaia', optLabel: 'Paraguaia'},
  {optValue: 'Paquistanesa', optLabel: 'Paquistanesa'},
  {optValue: 'Peruana', optLabel: 'Peruana'},
  {optValue: 'Polonesa', optLabel: 'Polonesa'},
  {optValue: 'Porto Riquenho', optLabel: 'Porto Riquenho'},
  {optValue: 'Portuguesa', optLabel: 'Portuguesa'},
  {optValue: 'Queniana', optLabel: 'Queniana'},
  {optValue: 'Romena', optLabel: 'Romena'},
  {optValue: 'Russa', optLabel: 'Russa'},
  {optValue: 'Salvadorense', optLabel: 'Salvadorense'},
  {optValue: 'Samoana', optLabel: 'Samoana'},
  {optValue: 'Sérvia', optLabel: 'Sérvia'},
  {optValue: 'Sul Coreana', optLabel: 'Sul Coreana'},
  {optValue: 'Sudanense', optLabel: 'Sudanense'},
  {optValue: 'Sueca', optLabel: 'Sueca'},
  {optValue: 'Suíça', optLabel: 'Suíça'},
  {optValue: 'Tailandesa', optLabel: 'Tailandesa'},
  {optValue: 'Tcheca', optLabel: 'Tcheca'},
  {optValue: 'Trinitária', optLabel: 'Trinitária'},
  {optValue: 'Turca', optLabel: 'Turca'},
  {optValue: 'Ucraniana', optLabel: 'Ucraniana'},
  {optValue: 'Uruguaia', optLabel: 'Uruguaia'},
  {optValue: 'Venezuelana', optLabel: 'Venezuelana'},
  {optValue: 'Vietnamita', optLabel: 'Vietnamita'},
];

export const states = [
  {state: 'Acre', uf: 'AC'},
  {state: 'Alagoas', uf: 'AL'},
  {state: 'Amapá', uf: 'AP'},
  {state: 'Amazonas', uf: 'AM'},
  {state: 'Bahia', uf: 'BA'},
  {state: 'Ceará', uf: 'CE'},
  {state: 'Distrito Federal', uf: 'DF'},
  {state: 'Espírito Santo', uf: 'ES'},
  {state: 'Goiás', uf: 'GO'},
  {state: 'Maranhão', uf: 'MA'},
  {state: 'Mato Grosso', uf: 'MT'},
  {state: 'Mato Grosso do Sul', uf: 'MS'},
  {state: 'Minas Gerais', uf: 'MG'},
  {state: 'Pará', uf: 'PA'},
  {state: 'Paraíba', uf: 'PB'},
  {state: 'Paraná', uf: 'PR'},
  {state: 'Pernambuco', uf: 'PE'},
  {state: 'Piauí', uf: 'PI'},
  {state: 'Rio de Janeiro', uf: 'RJ'},
  {state: 'Rio Grande do Norte', uf: 'RN'},
  {state: 'Rio Grande do Sul', uf: 'RS'},
  {state: 'Rondônia', uf: 'RO'},
  {state: 'Roraima', uf: 'RR'},
  {state: 'Santa Catarina', uf: 'SC'},
  {state: 'São Paulo', uf: 'SP'},
  {state: 'Sergipe', uf: 'SE'},
  {state: 'Tocantins', uf: 'TO'},
];

export const orgaoExpedidor = [
  {optValue: 'OAB', optLabel: 'OAB'},
  {optValue: 'CRM', optLabel: 'CRM'},
  {optValue: 'ABEXCON', optLabel: 'ABEXCON'},
  {optValue: 'CBM', optLabel: 'CBM'},
  {optValue: 'CRA', optLabel: 'CRA'},
  {optValue: 'CRBM', optLabel: 'CRBM'},
  {optValue: 'CRC', optLabel: 'CRC'},
  {optValue: 'CREA', optLabel: 'CREA'},
  {optValue: 'CREES', optLabel: 'CREES'},
  {optValue: 'CRF', optLabel: 'CRF'},
  {optValue: 'CRMV', optLabel: 'CRMV'},
  {optValue: 'CRO', optLabel: 'CRO'},
  {optValue: 'CRP', optLabel: 'CRP'},
  {optValue: 'CRQ', optLabel: 'CRQ'},
  {optValue: 'IPF', optLabel: 'IPF'},
  {optValue: 'SJS', optLabel: 'SJS'},
  {optValue: 'TJ', optLabel: 'TJ'},
  {optValue: 'TRT', optLabel: 'TRT'},
];

export const orgaoExpedidorRg = [
  {optValue: 'SSP', optLabel: 'SSP'},
  {optValue: 'IFP', optLabel: 'IFP'},
  {optValue: 'SESP', optLabel: 'SESP'},
  {optValue: 'DETRAN', optLabel: 'DETRAN'},
];

export const orgaoExpedidorCnh = [{optValue: 'DETRAN', optLabel: 'DETRAN'}];

export const orgaoExpedidorRne = [
  {optValue: 'DPF', optLabel: 'DPF (Departamento polícia federal)'},
];

export const regime_bens = [
  {
    optValue: PropertyRegime.COMUNHAO_PARCIAL,
    optLabel: 'Regime de Comunhão Parcial de Bens',
  },
  {optValue: PropertyRegime.REGIME_LEGAL_BENS, optLabel: 'Regime Legal de Bens'},
  {optValue: PropertyRegime.SEPARACAO_TOTAL_BENS, optLabel: 'Regime da Separação Total de Bens'},
  {optValue: PropertyRegime.COMUNHAO_UNIVERSAL, optLabel: 'Regime de Comunhão Universal'},
  {
    optValue: PropertyRegime.PARTICIPACAO_FINAL_AQUESTOS,
    optLabel: 'Regime de Participação Final nos Aquestos',
  },
];

export const interdito = [
  {optValue: 'Espólio', optLabel: 'Espólio'},
  {optValue: 'Interdito', optLabel: 'Interdito'},
  {optValue: 'Menor de 18 anos', optLabel: 'Menor de 18 anos'},
];

export const tipo_conta = [
  {optValue: AccountType.CONTA_CORRENTE, optLabel: 'conta corrente'},
  {optValue: AccountType.CONTA_POUPANCA, optLabel: 'conta poupança'},
];

export const tipo_sociedade = [
  {optValue: 'SIMPLES', optLabel: 'Simples'},
  {optValue: 'LTDA', optLabel: 'LTDA'},
  {optValue: 'SA', optLabel: 'S/A'},
  {optValue: 'NOME_COLETIVO', optLabel: 'Nome Coletivo'},
  {optValue: 'COOPERATIVA', optLabel: 'Cooperativa'},
  {optValue: 'UNIPESSOAL', optLabel: 'Unipessoal'},
  {optValue: 'COMANDITA_ACOES', optLabel: 'Comandita por Ações'},
  {optValue: 'COMANDITA_SIMPLES', optLabel: 'Comandita Simples'},
  {optValue: 'CONTA_PARTICIPACAO', optLabel: 'Conta de Participação'},
];

export const documents = [
  {optValue: DocumentType.RG, optLabel: 'RG'},
  {optValue: DocumentType.RNE, optLabel: 'RNE'},
  {optValue: DocumentType.CNH, optLabel: 'CNH'},
];

export const estado_civil = [
  {optValue: EstadoCivil.CASADO, optLabel: 'Casado'},
  {optValue: EstadoCivil.DIVORCIADO, optLabel: 'Divorciado'},
  {optValue: EstadoCivil.SEPARADO, optLabel: 'Separado'},
  {optValue: EstadoCivil.SOLTEIRO, optLabel: 'Solteiro'},
  {optValue: EstadoCivil.VIUVO, optLabel: 'Viúvo'},
];

export const sexo = [
  {optValue: 'MASCULINO', optLabel: 'Masculino'},
  {optValue: 'FEMININO', optLabel: 'Feminino'},
];

export const bancos = [
  {optValue: '341', optLabel: '341-ITAÚ UNIBANCO S.A'},
  {optValue: '104', optLabel: '104-CAIXA ECONÔMICA FEDERAL (CEF)'},
  {optValue: '237', optLabel: '237-BRADESCO S.A'},
  {optValue: '001', optLabel: '001-BANCO DO BRASIL S.A (BB)'},
  {optValue: '033', optLabel: '033-BANCO SANTANDER BRASIL S.A'},
  {optValue: '260', optLabel: '260-NU PAGAMENTOS S.A (NUBANK)'},
  {optValue: '422', optLabel: '422-BANCO SAFRA S.A'},
  {optValue: '077', optLabel: '077-BANCO INTER S.A'},
  {optValue: '756', optLabel: '756-BANCOOB (BANCO COOPERATIVO DO BRASIL)'},
  {optValue: '102', optLabel: '102-XP INVESTIMENTOS S.A'},
  {optValue: '748', optLabel: '748-SICREDI S.A'},
  {optValue: '212', optLabel: '212-BANCO ORIGINAL S.A'},
  {optValue: '117', optLabel: '117-ADVANCED CC LTDA'},
  {optValue: '172', optLabel: '172-ALBATROSS CCV S.A'},
  {optValue: '188', optLabel: '188-ATIVA S.A INVESTIMENTOS'},
  {optValue: '280', optLabel: '280-AVISTA S.A'},
  {optValue: '080', optLabel: '080-B&T CC LTDA'},
  {optValue: '121', optLabel: '121-BANCO AGIBANK S.A'},
  {optValue: '025', optLabel: '025-BANCO ALFA S.A.'},
  {optValue: '641', optLabel: '641-BANCO ALVORADA S.A'},
  {optValue: '065', optLabel: '065-BANCO ANDBANK S.A'},
  {optValue: '096', optLabel: '096-BANCO B3 S.A'},
  {optValue: '246', optLabel: '246-BANCO ABC BRASIL S.A'},
  {optValue: '021', optLabel: '021-BANCO BANESTES S.A'},
  {optValue: '036', optLabel: '036-BANCO BBI S.A'},
  {optValue: '047', optLabel: '047-BANCO BCO DO ESTADO DE SERGIPE S.A'},
  {optValue: '250', optLabel: '250-BANCO BCV'},
  {optValue: '318', optLabel: '318-BANCO BMG S.A'},
  {optValue: '107', optLabel: '107-BANCO BOCOM BBM S.A'},
  {optValue: '063', optLabel: '063-BANCO BRADESCARD'},
  {optValue: '122', optLabel: '122-BANCO BRADESCO BERJ S.A'},
  {optValue: '204', optLabel: '204-BANCO BRADESCO CARTOES S.A'},
  {optValue: '394', optLabel: '394-BANCO BRADESCO FINANCIAMENTOS S.A'},
  {optValue: '218', optLabel: '218-BANCO BS2 S.A'},
  {optValue: '208', optLabel: '208-BANCO BTG PACTUAL S.A'},
  {optValue: '336', optLabel: '336-BANCO C6 S.A - C6 BANK'},
  {optValue: '473', optLabel: '473-BANCO CAIXA GERAL BRASIL S.A'},
  {optValue: '412', optLabel: '412-BANCO CAPITAL S.A'},
  {optValue: '040', optLabel: '040-BANCO CARGILL S.A'},
  {optValue: '320', optLabel: '320-BANCO CCB BRASIL S.A'},
  {optValue: '266', optLabel: '266-BANCO CEDULA S.A'},
  {optValue: '739', optLabel: '739-BANCO CETELEM S.A'},
  {optValue: '233', optLabel: '233-BANCO CIFRA'},
  {optValue: '745', optLabel: '745-BANCO CITIBANK S.A'},
  {optValue: '241', optLabel: '241-BANCO CLASSICO S.A'},
  {optValue: '095', optLabel: '095-BANCO CONFIDENCE DE CÂMBIO S.A'},
  {optValue: '222', optLabel: '222-BANCO CRÉDIT AGRICOLE BR S.A'},
  {optValue: '505', optLabel: '505-BANCO CREDIT SUISSE (BRL) S.A'},
  {optValue: '069', optLabel: '069-BANCO CREFISA S.A'},
  {optValue: '003', optLabel: '003-BANCO DA AMAZONIA S.A'},
  {optValue: '083', optLabel: '083-BANCO DA CHINA BRASIL S.A'},
  {optValue: '707', optLabel: '707-BANCO DAYCOVAL S.A'},
  {optValue: '070', optLabel: '070-BANCO DE BRASÍLIA (BRB)'},
  {optValue: '654', optLabel: '654-BANCO DIGIMAIS S.A'},
  {optValue: '335', optLabel: '335-BANCO DIGIO S.A'},
  {optValue: '037', optLabel: '037-BANCO DO ESTADO DO PARÁ S.A'},
  {optValue: '004', optLabel: '004-BANCO DO NORDESTE DO BRASIL S.A.'},
  {optValue: '196', optLabel: '196-BANCO FAIR CC S.A'},
  {optValue: '265', optLabel: '265-BANCO FATOR S.A'},
  {optValue: '224', optLabel: '224-BANCO FIBRA S.A'},
  {optValue: '626', optLabel: '626-BANCO FICSA S.A'},
  {optValue: '094', optLabel: '094-BANCO FINAXIS'},
  {optValue: '612', optLabel: '612-BANCO GUANABARA S.A'},
  {optValue: '012', optLabel: '012-BANCO INBURSA'},
  {optValue: '604', optLabel: '604-BANCO INDUSTRIAL DO BRASIL S.A'},
  {optValue: '653', optLabel: '653-BANCO INDUSVAL S.A'},
  {optValue: '630', optLabel: '630-BANCO INTERCAP S.A'},
  {optValue: '249', optLabel: '249-BANCO INVESTCRED UNIBANCO S.A'},
  {optValue: '479', optLabel: '479-BANCO ITAUBANK S.A'},
  {optValue: '184', optLabel: '184-BANCO ITAÚ BBA S.A'},
  {optValue: '029', optLabel: '029-BANCO ITAÚ CONSIGNADO S.A'},
  {optValue: '217', optLabel: '217-BANCO JOHN DEERE S.A'},
  {optValue: '376', optLabel: '376-BANCO J.P. MORGAN S.A'},
  {optValue: '076', optLabel: '076-BANCO KDB BRASIL S.A.'},
  {optValue: '757', optLabel: '757-BANCO KEB HANA DO BRASIL S.A'},
  {optValue: '300', optLabel: '300-BANCO LA NACION ARGENTINA'},
  {optValue: '600', optLabel: '600-BANCO LUSO BRASILEIRO S.A'},
  {optValue: '243', optLabel: '243-BANCO MÁXIMA S.A'},
  {optValue: '389', optLabel: '389-BANCO MERCANTIL DO BRASIL S.A'},
  {optValue: '370', optLabel: '370-BANCO MIZUHO S.A'},
  {optValue: '746', optLabel: '746-BANCO MODAL S.A'},
  {optValue: '066', optLabel: '066-BANCO MORGAN STANLEY S.A'},
  {optValue: '456', optLabel: '456-BANCO MUFG BRASIL S.A'},
  {optValue: '169', optLabel: '169-BANCO OLÉ BONSUCESSO CONSIGNADO S.A'},
  {optValue: '111', optLabel: '111-BANCO OLIVEIRA TRUST DTVM S.A'},
  {optValue: '079', optLabel: '079-BANCO ORIGINAL DO AGRONEGÓCIO S.A'},
  {optValue: '712', optLabel: '712-BANCO OURINVEST S.A'},
  {optValue: '623', optLabel: '623-BANCO PAN'},
  {optValue: '611', optLabel: '611-BANCO PAULISTA'},
  {optValue: '643', optLabel: '643-BANCO PINE S.A'},
  {optValue: '747', optLabel: '747-BANCO RABOBANK INTERNACIONAL DO BRASIL S.A'},
  {optValue: '633', optLabel: '633-BANCO RENDIMENTO S.A'},
  {optValue: '494', optLabel: '494-BANCO REP ORIENTAL URUGUAY'},
  {optValue: '741', optLabel: '741-BANCO RIBEIRÃO PRETO'},
  {optValue: '120', optLabel: '120-BANCO RODOBENS S.A'},
  {optValue: '743', optLabel: '743-BANCO SEMEAR S.A'},
  {optValue: '754', optLabel: '754-BANCO SISTEMA'},
  {optValue: '366', optLabel: '366-BANCO SOCIETE GENERALE BRASIL'},
  {optValue: '637', optLabel: '637-BANCO SOFISA S.A (SOFISA DIRETO)'},
  {optValue: '464', optLabel: '464-BANCO SUMITOMO MITSUI BRASIL S.A'},
  {optValue: '082', optLabel: '082-BANCO TOPÁZIO S.A'},
  {optValue: '634', optLabel: '634-BANCO TRIANGULO S.A (BANCO TRIÂNGULO)'},
  {optValue: '018', optLabel: '018-BANCO TRICURY S.A'},
  {optValue: '655', optLabel: '655-BANCO VOTORANTIM S.A'},
  {optValue: '610', optLabel: '610-BANCO VR S.A'},
  {optValue: '119', optLabel: '119-BANCO WESTERN UNION'},
  {optValue: '124', optLabel: '124-BANCO WOORI BANK DO BRASIL S.A'},
  {optValue: '348', optLabel: '348-BANCO XP S/A'},
  {optValue: '041', optLabel: '041-BANRISUL – BANCO DO ESTADO DO RIO GRANDE DO SUL S.A'},
  {optValue: '197', optLabel: '197-STONE PAGAMENTOS S.A'},
  {optValue: '290', optLabel: '290-PAGSEGURO INTERNET S.A (PAGBANK)'},
  {optValue: '380', optLabel: '380-PICPAY SERVICOS S.A.'},
  {optValue: '323', optLabel: '323-MERCADO PAGO - CONTA DO MERCADO LIVRE'},
  {optValue: '655', optLabel: '655-NEON PAGAMENTOS S.A'},
  {optValue: '237', optLabel: '237-NEXT BANK'}
];

export interface RegistryOffices {
  state: string;
  cities: City[];
}

export interface City {
  id: number;
  name: string;
  registries: Registry[];
}

export interface Registry {
  codigo_cartorio: number;
  nome: string;
  cidade: string;
  id_cidade: number;
}
